export default function Liens() {
  const links = [
    { name: "AGOEER", url: "https://agoeer.ch/" },
    { name: "ICEM - pédagogie Freinet", url: "https://www.icem-pedagogie-freinet.org/" },
    { name: "Groupe Romand d'Education Nouvelle", url: "http://www.education-nouvelle.ch/" },
    { name: "Lien International d'Education Nouvelle", url: "http://lelien2.org/" },
    { name: "AGEPES", url: "http://www.agepes.org/" },
    { name: "Association des parents d'élèves (APEVL)", url: "https://www.lavoielactee.ch/index.php?page=contact&lang=fr" },
  ];
  return (
    <main className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">Liens</h1>
      <div className="mt-6 grid sm:grid-cols-2 md:grid-cols-3 gap-4">
        {links.map(l => (
          <a key={l.url} href={l.url} target="_blank" rel="noreferrer" className="p-4 rounded-xl border hover:bg-orange-50 text-amber-700 font-semibold">{l.name}</a>
        ))}
      </div>
    </main>
  );
}